import { FC } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DOCS_NAV_ITEMS } from "../utils";

export const DocsSidebar: FC = () => {
  const { t } = useTranslation();

  return (
    // Below md the sections travel in a single horizontal strip that scrolls: a vertical sidebar on a
    // phone would push the content a whole screen down.
    // YOSHI-10464: from md the rail stays in sight while a long page such as the reference or the
    // glossary is read. `self-start` is what makes that work: as one more item of the row it was
    // stretched to the height of the content, and a box that is already as tall as its container has
    // nowhere to stick to. It starts below the fixed 6rem header and scrolls on its own when the
    // seven sections outgrow the window.
    <nav
      aria-label={t("docs.common.sectionsNav")}
      className="md:sticky md:top-32 md:max-h-[calc(100vh-10rem)] md:w-60 md:shrink-0 md:self-start md:overflow-y-auto"
    >
      <ul className="flex md:flex-col gap-2 md:gap-1 overflow-x-auto md:overflow-x-visible pb-3 md:pb-0 border-b md:border-b-0 border-gray-200">
        {DOCS_NAV_ITEMS.map((item) => (
          <li key={item.to} className="shrink-0">
            <NavLink
              id={`docs-nav-${item.translationKey}`}
              to={item.to}
              // `end` only on the index route: without it every section would light up the
              // overview link too, since they all hang from /docs.
              end={item.to === "/docs"}
              className={({ isActive }) =>
                `block break-words rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary/10 text-primary font-semibold"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
                }`
              }
            >
              {t(`docs.nav.${item.translationKey}`)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
